import React from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
} from 'reactstrap';

const GeneralTab = () => {
  return (
    <div>
      <h5 className="mb-3">Configuración General</h5>
      <Row>
        <Col md="6">
          <Card className="mb-3">
            <CardBody>
              <h6>Información del Sistema</h6>
              <p className="mb-1">
                <strong>Plataforma:</strong> BGL CRM
              </p>
              <p className="mb-1">
                <strong>Versión:</strong> 1.0.0
              </p>
              <p className="mb-0">
                <strong>Ambiente:</strong>{' '}
                {process.env.NODE_ENV || 'development'}
              </p>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default GeneralTab;
